export const initialDataResource = {
    name: "",
    phone: "",
    cpf: "",
    email: "",
    login: "",
    password: "",
    gitlab_user: "",
    second_phone: "",
    team: "",
    is_commercial: false,
    is_inactive: false,
}